import React, { useEffect } from "react"
import { Box, Grid, Heading } from "@theme-ui/components"
import { InboundLink } from "./link"
import { getPagePath } from "../utils/path"
import { LanguageSwitcherContext } from "../context/languageSwitcherContext"
import { stagger, useAnimate } from "framer-motion"
import { useBreakpointIndex } from "@theme-ui/match-media"
const MultipleTitle = ({ block }) => {
  const locale = React.useContext(LanguageSwitcherContext).activeLocale
  const breakpointIndex = useBreakpointIndex()
  const [topTitle, animateTopTitle] = useAnimate()
  const [bottomTitle, animateBottomTitle] = useAnimate()
  const [links, animateLinks] = useAnimate()

  const topTitleY = {
    0: 60,
    1: 85,
    2: 140,
    3: 140,
  }

  const bottomTitleY = {
    0: -60,
    1: -85,
    2: -140,
    3: -140,
  }

  useEffect(() => {
    const animation = async () => {
      await animateTopTitle(
        topTitle.current,
        { y: [topTitleY[breakpointIndex], 0] },
        { delay: 0.5, duration: 0.7, ease: "anticipate" }
      )
    }
    animation()
  }, [breakpointIndex])

  useEffect(() => {
    const animation = async () => {
      await animateBottomTitle(
        bottomTitle.current,
        { y: [bottomTitleY[breakpointIndex], 0] },
        { delay: 0.5, duration: 0.7, ease: "anticipate" }
      )
    }
    animation()
  }, [breakpointIndex])

  useEffect(() => {
    const animation = async () => {
      await animateLinks([
        [
          links.current,
          { scale: [0.9, 1], opacity: [0, 1] },
          { delay: 0.2, duration: 0.7, ease: "anticipate" },
        ],
        [
          "a",
          { y: [20, 0], opacity: [0, 1] },
          { delay: stagger(0.3), duration: 0.7, ease: "anticipate" },
        ],
      ])
    }
    animation()
  }, [breakpointIndex])

  console.log("breakpoint", breakpointIndex)
  console.log(block.links)

  return (
    <Box sx={{ mt: [5, 0, 0, 6], py: [6, 7, 7, 9], position: "relative" }}>
      <Grid columns={[1, 1, "1fr"]} sx={{ textAlign: "center" }} gap={[0]}>
        <Box ref={topTitle}>
          <Heading variant="h2" sx={{ fontSize: [6, 7, "110px", "110px"] }}>
            {block.title1}
          </Heading>
        </Box>
        <Box ref={links}>
          {block.links &&
            block.links.map((link, index) => (
              <Box
                sx={{
                  a: {
                    display: "inline-block",
                    fontSize: [6, 7, "110px", "110px"],
                    lineHeight: "heading",
                    textTransform: "uppercase",
                    textDecoration: "none",
                    fontWeight: 700,
                    color: "primary",
                    lineHeight: 0.9,
                    ":hover": {
                      color: "secondary",
                      transition: "color 200ms ease-out",
                    },
                  },
                }}
                key={index}
              >
                <InboundLink to={getPagePath(link.link, locale)}>
                  {link.anchor}
                </InboundLink>
              </Box>
            ))}
        </Box>
        <Box ref={bottomTitle}>
          <Heading variant="h2" sx={{ fontSize: [6, 7, "110px", "110px"] }}>
            {block.title2}
          </Heading>
        </Box>
      </Grid>
    </Box>
  )
}

export default MultipleTitle
